export const moduleType = (state = '') => state;
